import { render, staticRenderFns } from "./CoinDetailView.vue?vue&type=template&id=6fae3a21&scoped=true"
import script from "./CoinDetailView.vue?vue&type=script&lang=js"
export * from "./CoinDetailView.vue?vue&type=script&lang=js"
import style0 from "./CoinDetailView.vue?vue&type=style&index=0&id=6fae3a21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fae3a21",
  null
  
)

export default component.exports